<template>
  <c-flex mr="-30px" ml="-30px" flexDirection="column">
    <c-box
      height="330px"
      background="#4b4b4b"
      backgroundImage="url(/img/support/header.jpg)"
      backgroundPosition="center"
      backgroundSize="cover"
      borderRadius="base"
      position="relative"
      overflow="hidden"
      mr="xl"
      v-chakra="{
        '@media (min-width: 2048px)': {
          mr: '0',
        },
      }"
      :mt="{ base: '3xl', sm: '3rem', md: '4xl' }"
      :ml="{ base: 'xl', xl: '2xl' }"
      maxWidth="100%"
    >
    </c-box>
    <c-flex
      :ml="{ base: 'xl', xl: '2xl' }"
      mt="3xl"
      mr="xl"
      v-chakra="{
        '@media (min-width: 2048px)': {
          mr: '0',
        },
      }"
      justifyContent="center"
      flexWrap="wrap"
    >
      <c-box
        v-chakra="{
          '@media (min-width: 1500px)': {
            width: '0',
            flex: '1 0 30%',
          },
        }"
        :width="{ base: '100%', md: '50%' }"
      >
        <c-box
          borderRadius="base"
          background="white"
          overflow="hidden"
          height="100%"
          pr="3xl"
          pl="3xl"
          pt="2xl"
          pb="xl"
          v-chakra="{
            '@media (min-width: 2048px)': {
              mr: '0',
            },
          }"
          :mr="{ md: 'md' }"
          boxShadow="base"
        >
          <c-heading data-cy="partners" color="brand.purple" lineHeight="1.5em" as="h3">{{
            $t("support.partners.title")
          }}</c-heading>
          <c-text color="black" mt="xl" mb="xl">{{ $t("support.partners.text") }}</c-text>
          <c-box mt="2xl">
            <c-text v-if="supportContact.phone" mt="xl" mb="xl">
              <c-icon name="phone" size="2rem" mr="xl" color="deepBlack" />
              <c-link color="brand.purple" fontSize="lg" :href="`tel:${supportContact.phone}`">
                {{ supportContact.phoneDisplay }}
              </c-link>
            </c-text>
            <c-text mt="xl" mb="xl">
              <c-icon name="email" size="2rem" mr="xl" color="deepBlack" />
              <c-link color="brand.purple" fontSize="lg" :href="`mailto:${supportContact.email}`">
                {{ supportContact.email }}
              </c-link>
            </c-text>
          </c-box>
        </c-box>
      </c-box>
      <c-box
        v-chakra="{
          '@media (min-width: 1500px)': {
            width: '0',
            flex: '1 0 30%',
          },
        }"
        :mt="{ base: 'xl', md: '0' }"
        :width="{ base: '100%', md: '50%' }"
      >
        <c-box
          borderRadius="base"
          background="white"
          overflow="hidden"
          height="100%"
          pr="3xl"
          pl="3xl"
          pt="2xl"
          pb="xl"
          v-chakra="{
            '@media (min-width: 1500px)': {
              mr: 'md',
            },
            '@media (min-width: 2048px)': {
              mr: '0',
            },
          }"
          :ml="{ md: 'md' }"
          boxShadow="base"
        >
          <c-heading color="brand.purple" lineHeight="1.5em" as="h3">{{
            $t("support.architects.title")
          }}</c-heading>
          <c-text color="black" mt="xl" mb="xl">{{ $t("support.architects.text") }}</c-text>
          <c-box mt="2xl">
            <c-text v-if="salesContact.phone" mt="xl" mb="xl">
              <c-icon name="phone" size="2rem" mr="xl" color="deepBlack" />
              <c-link color="brand.purple" fontSize="lg" :href="`tel:${salesContact.phone}`">
                {{ salesContact.phoneDisplay }}
              </c-link>
            </c-text>
            <c-text mt="xl" mb="xl">
              <c-icon name="email" size="2rem" mr="xl" color="deepBlack" />
              <c-link color="brand.purple" fontSize="lg" :href="`mailto:${salesContact.email}`">
                {{ salesContact.email }}
              </c-link>
            </c-text>
          </c-box>
        </c-box>
      </c-box>
      <c-box
        :width="{ base: '100%', md: '50%' }"
        v-chakra="{
          '@media (min-width: 1500px)': {
            width: '0',
            mt: '0',
            flex: '1 0 30%',
          },
        }"
        mt="xl"
      >
        <c-box
          borderRadius="base"
          background="white"
          overflow="hidden"
          height="100%"
          pr="3xl"
          pl="3xl"
          pt="2xl"
          pb="xl"
          :mr="{ md: 'md' }"
          v-chakra="{
            '@media (min-width: 1500px)': {
              ml: 'md',
              mr: '0',
              mt: '0',
              flex: '1 0 30%',
            },
          }"
          boxShadow="base"
        >
          <c-heading color="brand.purple" lineHeight="1.5em" as="h3">{{
            $t("support.customerService.title")
          }}</c-heading>
          <c-text color="black" mt="xl" mb="xl">{{ $t("support.customerService.text") }}</c-text>
          <c-box mt="2xl">
            <c-text v-if="customerServiceContact.phone" mt="xl" mb="xl">
              <c-icon name="phone" size="2rem" mr="xl" color="deepBlack" />
              <c-link
                color="brand.purple"
                fontSize="lg"
                :href="`tel:${customerServiceContact.phone}`"
              >
                {{ customerServiceContact.phoneDisplay }}
              </c-link>
            </c-text>
            <c-text mt="xl" mb="xl">
              <c-icon name="email" size="2rem" mr="xl" color="deepBlack" />
              <c-link
                color="brand.purple"
                fontSize="lg"
                :href="`mailto:${customerServiceContact.email}`"
              >
                {{ customerServiceContact.email }}
              </c-link>
            </c-text>
          </c-box>
        </c-box>
      </c-box>
      <c-box
        v-chakra="{
          '@media (min-width: 1500px)': {
            width: '0',
            mt: '4xl',
            flex: '1 0 30%',
            maxWidth: '60%',
          },
        }"
        :width="{ base: '100%', md: '50%' }"
        mt="xl"
      >
        <c-flex
          flexDirection="column"
          alignItems="left"
          borderRadius="base"
          overflow="hidden"
          height="100%"
          pr="3xl"
          pl="3xl"
          pt="2xl"
          pb="xl"
          :mr="{ md: 'md' }"
          v-chakra="{
            '@media (min-width: 1500px)': {
              mr: '0',
            },
          }"
        >
          <c-box>
            <c-heading color="brand.purple" lineHeight="1.5em" fontSize="1.5rem" as="h3">{{
              $t("support.remote.title")
            }}</c-heading>
            <c-text mt="sm" md="sm">
              {{ $t("support.remote.text") }}
              <c-link
                fontWeight="bold"
                color="brand.purple"
                textDecoration="none"
                :_hover="{
                  textDecoration: 'none',
                  color: 'brand.purple',
                }"
                :href="$t('support.remote.linkAddress')"
                >{{ $t("support.remote.linkText") }}</c-link
              >
            </c-text>
          </c-box>
          <c-link
            fontWeight="bold"
            color="brand.purple"
            textDecoration="none"
            :href="$t('support.remote.linkAddress')"
            :_hover="{
              textDecoration: 'none',
              color: 'brand.purple',
            }"
          >
            <c-flex alignItems="center">
              <c-text fontSize="sm" fontWeight="bold">{{ $t("support.remote.teamviewer") }}</c-text>
              <c-image src="/img/support/iLOQ-TeamViewer.svg" w="32" alt="Teamviewer logo" />
            </c-flex>
          </c-link>
        </c-flex>
      </c-box>
    </c-flex>
  </c-flex>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { CHeading, CLink, CText, CBox, CFlex, CIcon, CImage } from "@chakra-ui/vue";
import { IRootState, User } from "@iloq/shared";

const supportContactsByCountryCode: any = {
  FI: {
    email: "support.suomi@iloq.com",
    phone: "+358403170203",
    phoneDisplay: "+358 (0)40 3170 203",
  },
  SE: {
    email: "support.sverige@iloq.com",
    phone: "+4686507201",
    phoneDisplay: "+46 (0)8 650 7201",
  },
  NO: {
    email: "support.norge@iloq.com",
    phone: "+4722120900",
    phoneDisplay: "+47 22 12 09 00",
  },
  DK: {
    email: "support.danmark@iloq.com",
    phone: "+4586261660",
    phoneDisplay: "+45 8626 1660",
  },
  NL: {
    email: "support.nederland@iloq.com",
    phone: "+31882024505",
    phoneDisplay: "+31 (0)88 202 4505",
  },
  DE: {
    email: "support.deutschland@iloq.com",
    phone: "+4921197177475",
    phoneDisplay: "+49 (0) 211 97 177 475",
  },
  FR: {
    email: "support.france@iloq.com",
    phone: "+33181801431",
    phoneDisplay: "+ 33 1 81 80 14 31",
  },
  ES: {
    email: "support.spain@iloq.com",
    phone: "+34931016779",
    phoneDisplay: "+34 931 016 779",
  },
  /* TODO missing
  IT: {
    email: 'support@iloq.com',
    phone: '+358403170203',
    phoneDisplay: '+358 (0)40 3170 203',
  },
  GB: {
    email: 'support@iloq.com',
    phone: '+358403170203',
    phoneDisplay: '+358 (0)40 3170 203',
  },
  */
  US: {
    email: "support.usa@iloq.com",
    phone: "+13478511630",
    phoneDisplay: "+1 347-851-1630",
  },
  AU: {
    email: "support.australia@iloq.com",
    phone: "+61391018028",
    phoneDisplay: "+61 (3) 9101 8028",
  },
  NZ: {
    email: "support.australia@iloq.com",
    phone: "+61391018028",
    phoneDisplay: "+61 (3) 9101 8028",
  },
  BR: {
    email: "support.latam@iloq.com",
  },
  OTHER: {
    email: "support@iloq.com",
    phone: "+358403170202",
    phoneDisplay: "+358 (0)40 3170 202",
  },
};
const customerServiceContactsByCountryCode: any = {
  FI: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  SE: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  NO: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  DK: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  NL: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  DE: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  FR: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  ES: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  /* TODO missing
  IT: {
    email: 'support@iloq.com',
    phone: '+358403170203',
    phoneDisplay: '+358 (0)40 3170 203',
  },
  GB: {
    email: 'support@iloq.com',
    phone: '+358403170203',
    phoneDisplay: '+358 (0)40 3170 203',
  },
  */
  US: {
    email: "customer.service@iloq.com",
  },
  AU: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  NZ: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
  OTHER: {
    email: "customer.service@iloq.com",
    phone: "+358403170205",
    phoneDisplay: "+358 (0)40 3170 205",
  },
};
const salesContactsByCountryCode: any = {
  FI: {
    email: "myynti@iloq.com",
    phone: "+358403170204",
    phoneDisplay: "+358 (0)40 3170 204",
  },
  SE: {
    email: "arkitektsupport.sverige@iloq.com",
    phone: "+4686507201",
    phoneDisplay: "+46 (0)8 650 7203",
  },
  NO: {
    email: "norway@iloq.com",
    phone: "+4722120900",
    phoneDisplay: "+47 22 12 09 00",
  },
  DK: {
    email: "denmark@iloq.com",
    phone: "+4586261660",
    phoneDisplay: "+45 8626 1660",
  },
  NL: {
    email: "nederland@iloq.com",
    phone: "+31882024500",
    phoneDisplay: "+31(0)88 202 4500",
  },
  DE: {
    email: "germany@iloq.com",
    phone: "+4921197177480",
    phoneDisplay: "+49 (0) 211 97 177 480",
  },
  FR: {
    email: "france@iloq.com",
    phone: "+33181801430",
    phoneDisplay: "+ 33 1 81 80 14 30",
  },
  ES: {
    email: "support.spain@iloq.com",
    phone: "+34931016778",
    phoneDisplay: "+34 931 016 778",
  },
  /* TODO missing
  IT: {
    email: 'sales@iloq.com',
    phone: '+358403170204',
    phoneDisplay: '+358 (0)40 3170 204',
  },
  GB: {
    email: 'sales@iloq.com',
    phone: '+358403170204',
    phoneDisplay: '+358 (0)40 3170 204',
  },
  */
  US: {
    email: "robert.mancuso@iloq.com",
  },
  AU: {
    email: "peter.kardaras@iloq.com",
    phone: "+610448850327",
    phoneDisplay: "+61 (0)448 850 327",
  },
  NZ: {
    email: "peter.kardaras@iloq.com",
    phone: "+610448850327",
    phoneDisplay: "+61 (0)448 850 327",
  },
  OTHER: {
    email: "sales@iloq.com",
    phone: "+358403170204",
    phoneDisplay: "+358 (0)40 3170 204",
  },
};

const getCountryCode = (user: User): string =>
  user.groups.indexOf("Country_OTHER") >= 0 ? "OTHER" : user.countryCode;

export default defineComponent({
  name: "Support",
  components: {
    CHeading,
    CLink,
    CText,
    CBox,
    CFlex,
    CIcon,
    CImage,
  },
  computed: {
    ...mapState({
      user: (state: unknown) => (state as IRootState).user!,
    }),
    supportContact(): any {
      return (
        supportContactsByCountryCode[getCountryCode((this as any).user)] ||
        supportContactsByCountryCode.OTHER
      );
    },
    salesContact(): any {
      return (
        salesContactsByCountryCode[getCountryCode((this as any).user)] ||
        salesContactsByCountryCode.OTHER
      );
    },
    customerServiceContact(): any {
      return (
        customerServiceContactsByCountryCode[getCountryCode((this as any).user)] ||
        customerServiceContactsByCountryCode.OTHER
      );
    },
  },
});
</script>
